var exports = {
  "p": "xe533113f--db1334--filter",
};

module.exports = exports;
